import { useMemo } from 'react';
import { getColumnWidthsInitialState } from '../helpers/tableHelpers';
import { usePrevious } from './usePrevious';

export const useMemoizedColumns = ({
  resetTableValue,
  columns,
  tableName,
} = {}) => {
  const prevResetTableValue = usePrevious(resetTableValue);

  return useMemo(() => {
    const hasBeenReset = resetTableValue !== prevResetTableValue;
    if (hasBeenReset || !tableName) {
      return columns || [];
    }

    return getColumnWidthsInitialState(columns, tableName);
  }, [resetTableValue, prevResetTableValue, columns, tableName]);
};
